<template>
  <Loading v-if="componentLoading" :style="style" />
  <Chart v-else-if="visible" class="compare-line-chart" :option="chartConfig" :style="style"></Chart>
</template>

<script lang="ts" setup>
import Chart from "@p-v/packages/Charts/BaseChart/index.vue"
import Loading from "@p-v/packages/Loading.vue"
import { ref } from "vue"
import { cloneDeep, defaultsDeep } from "lodash-es"
import config from "./config"
import useToggle from "@p-v/hooks/useToggle"
import type { DataItem, CompareLineChartProps } from "./index.d"
import { EChartsOption } from "echarts"

const componentLoading = ref<boolean>(true)

const props = withDefaults(defineProps<CompareLineChartProps>(), {
  config: () => ({}),
  style: () => ({}),
  show: () => true,
})
const { visible, show, hide, changeVisible } = useToggle(props.show)

const chartConfig = ref(cloneDeep(config))

// watch(
//   () => props,
//   propsData => {
//     // console.log('watch props', propsData);
//     if (propsData.dataList.length > 0) {
//       const result = componentPropEngine(propsData)
//       // console.log('result', result.series);
//       chartConfig.value = result
//     } else {
//       chartConfig.value = cloneDeep(config)
//     }
//   },
//   {
//     immediate: true,
//     deep: true,
//   },
// )

/**
 * 数据处理
 * @param config
 * @param dataList
 */
function componentPropEngine(propsData: CompareLineChartProps): EChartsOption {
  const { dataList, config: _config } = propsData
  const newConfig = cloneDeep(config)
  const configFromProp = cloneDeep(_config)
  const configResult = defaultsDeep(configFromProp, props.config, newConfig)

  const barData = dataList[0]
  const lineData = dataList[1]

  if (barData && lineData) {
    if (barData.name) {
      // configResult.yAxis[0].name = barData.unit;
      configResult.legend[0].data = [barData.name]
      configResult.series[0].name = barData.name
      configResult.series[0].data = barData.data
      configResult.xAxis[0].data = barData.axis
      configResult.xAxis[0].show = true
      if (barData.type) {
        configResult.series[0].type = barData.type
      }
      if (barData.axisOpt) {
        if (barData.axisOpt.min) {
          configResult.yAxis[0].min = barData.axisOpt.min
        }
        if (barData.axisOpt.max) {
          configResult.yAxis[0].max = barData.axisOpt.max
        }
        if (barData.axisOpt.splitNumber) {
          configResult.yAxis[0].splitNumber = barData.axisOpt.splitNumber
        }
        if (barData.axisOpt.interval) {
          configResult.yAxis[0].interval = barData.axisOpt.interval
        }
      }
    }
    if (lineData.name) {
      // configResult.yAxis[1].name = lineData.unit;
      configResult.legend[1].data = [lineData.name]
      configResult.series[1].name = lineData.name
      configResult.series[1].data = lineData.data
      configResult.xAxis[1].data = lineData.axis
      if (lineData.type) {
        configResult.series[1].type = lineData.type
      }
      if (lineData.axisOpt) {
        if (lineData.axisOpt.min) {
          configResult.yAxis[1].min = lineData.axisOpt.min
        }
        if (lineData.axisOpt.max) {
          configResult.yAxis[1].max = lineData.axisOpt.max
        }
        if (lineData.axisOpt.splitNumber) {
          configResult.yAxis[1].splitNumber = lineData.axisOpt.splitNumber
        }
        if (lineData.axisOpt.interval) {
          configResult.yAxis[1].interval = lineData.axisOpt.interval
        }
      }
    }

    if (barData.unit && lineData.unit) {
      configResult.yAxis[0].name = barData.unit
      configResult.yAxis[1].name = lineData.unit
      configResult.legend[0].left = "10%"
      configResult.legend[1].right = "10%"
    }

    configResult.xAxis[0].axisPointer.label.formatter = (params: { value: string | number; seriesData: { data: string | number }[] }) => {
      // console.log(params)
      return `${barData.name} ${params.value}${params.seriesData.length ? `：${params.seriesData[0].data} ${barData.unit}` : ""}`
    }
    configResult.xAxis[1].axisPointer.label.formatter = (params: { value: string | number; seriesData: { data: string | number }[] }) => {
      // console.log(params)
      return `${lineData.name} ${params.value}${params.seriesData.length ? `：${params.seriesData[0].data} ${lineData.unit}` : ""}`
    }

    if (barData.data && lineData.data) {
      // 移除暂无数据的文本
      // delete configResult.graphic;
      configResult.graphic[0].invisible = true
    } else {
      configResult.xAxis[0].data = []
      configResult.series = []
    }
  } else {
    configResult.xAxis[0].data = []
    configResult.series = []
  }

  return configResult
}
const loading = () => {
  componentLoading.value = true
}
const setData = (
  data:
    | [DataItem, DataItem]
    | {
        dataList: [DataItem, DataItem]
        config?: EChartsOption
      },
  option?: EChartsOption,
) => {
  if ("dataList" in data) {
    option = data.config
    data = data.dataList
  }
  const result = componentPropEngine({ dataList: data, config: option })
  chartConfig.value = result
  componentLoading.value = false
}
defineExpose({ setData, loading, show, hide, changeVisible })
</script>

<style lang="scss">
.compare-line-chart {
  height: 100%;
}
</style>
.
